import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useEligibilityData } from "../useEligibilityData";
import Navbar from "../../../components/molecules/Navbar";
import Footer from "../../../components/molecules/Footer";
import styles from "../index.module.css";

const STEPS = [
  { key: "submitted", label: "Application Submitted", sub: "Documents received", done: true },
  { key: "docs", label: "Documents Verified", sub: "Initial check completed", done: true },
  { key: "review", label: "Under Review", sub: "Being assessed by our team", active: true },
  { key: "decision", label: "Decision Pending", sub: "Final approval awaited", done: false },
];

function EligibilityUnderReview() {
  const navigate = useNavigate();
  const userData = useEligibilityData();

  useEffect(() => {
    const appId = userData?.applicationId;
    if (!appId) return;
    const token = sessionStorage.getItem("eligibility_auth_token");
    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${appId}`,
      { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => res.json())
      .then((res) => {
        const stage: number = res?.data?.stage;
        if (stage === undefined || stage === 5) return;
        const navData = userData;
        if (stage === 8) { navigate("/eligibility/congratulations", { replace: true, state: { data: navData } }); return; }
        if (stage === 9) { navigate("/eligibility/selfie", { replace: true, state: { data: navData } }); return; }
        if (stage === 11) { navigate("/eligibility/agreement", { replace: true, state: { data: navData } }); return; }
        if (stage === 12) { navigate("/eligibility/emandate", { replace: true, state: { data: navData } }); return; }
        if (stage === 24) { navigate("/eligibility/digilocker", { replace: true, state: { data: navData } }); return; }
        if (stage === 25) { navigate("/eligibility/evaluating", { replace: true, state: { data: navData } }); return; }
        if (stage === 18) { navigate("/eligibility/rejected", { replace: true, state: { data: navData } }); return; }
        if (stage === 10) { navigate("/eligibility/waiting", { replace: true, state: { data: navData, fromStage10: true } }); return; }
      })
      .catch(() => {});
  }, [userData?.applicationId]);

  return (
    <div className={styles.body}>
      <div className={styles.backdrop}>
        <Navbar />
        <div className={styles.main}>
          <div className={styles.cardWrapper}>
            <div className={styles.container}>

              {/* ── Badge ── */}
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "0.5rem", paddingBottom: "0.6rem" }}>
                <div
                  style={{
                    width: "72px",
                    height: "72px",
                    borderRadius: "20px",
                    background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 8px 24px rgba(245,158,11,0.32)",
                    marginBottom: "1rem",
                  }}
                >
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="2" />
                    <path d="M12 7V12L15 14.5" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>

                <p style={{ fontSize: "1.35rem", fontWeight: 800, color: "#1a1a2e", margin: "0 0 0.35rem", fontFamily: "Outfit, sans-serif", textAlign: "center", letterSpacing: "-0.3px" }}>
                  Application Under Review
                </p>
                {/* <p style={{ fontSize: "0.84rem", color: "#777", margin: 0, textAlign: "center", lineHeight: 1.55, whiteSpace: "nowrap" }}>
                  We're carefully reviewing your details.
                </p> */}
              </div>

              {/* ── Status Tracker ── */}
              <div style={{ background: "#fff", border: "1px solid #e8e8e8", borderRadius: "14px", padding: "1rem 1.15rem", marginBottom: "0.9rem" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.45rem", marginBottom: "1rem" }}>
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="9" stroke="#888" strokeWidth="1.6" />
                    <path d="M12 7V12L15 14.5" stroke="#888" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span style={{ fontSize: "0.65rem", fontWeight: 700, color: "#888", letterSpacing: "0.9px", textTransform: "uppercase" }}>
                    Status Tracker
                  </span>
                </div>

                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "20px",
                      bottom: "28px",
                      width: "2px",
                      background: "linear-gradient(to bottom, #f59e0b 50%, #e0e0e0 50%)",
                      zIndex: 0,
                    }}
                  />

                  {STEPS.map((step, idx) => (
                    <div
                      key={step.key}
                      style={{ display: "flex", alignItems: "flex-start", gap: "0.85rem", marginBottom: idx < STEPS.length - 1 ? "1rem" : 0, position: "relative", zIndex: 1 }}
                    >
                      {step.done ? (
                        <div style={{ width: "20px", height: "20px", borderRadius: "50%", background: "#f59e0b",marginTop:'0.5rem', display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
                            <path d="M3 7L6 10L11 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      ) : step.active ? (
                        <div style={{ width: "20px", height: "20px", borderRadius: "50%", border: "2.5px solid #f59e0b",marginTop:'0.5rem', background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          <div style={{ width: "12px", height: "10px", borderRadius: "50%", background: "#f59e0b", animation: "pulse 1.4s ease-in-out infinite" }} />
                        </div>
                      ) : (
                        <div style={{ width: "20px", height: "20px", borderRadius: "50%", border: "2px solid #e0e0e0",marginTop:'0.5rem', background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#e0e0e0" }} />
                        </div>
                      )}

                      <div style={{ paddingTop: "0.15rem" }}>
                        <p style={{ margin: "0 0 0.1rem", fontSize: "0.9rem", fontWeight: 700, color: step.active ? "#f59e0b" : step.done ? "#1a1a2e" : "#bbb", fontFamily: "Outfit, sans-serif" }}>
                          {step.label}
                        </p>
                        <p style={{ margin: 0, fontSize: "0.74rem", color: step.active ? "#f59e0b" : step.done ? "#888" : "#ccc", opacity: 1 }}>
                          {step.sub}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* ── Info note ── */}
              <div style={{ display: "flex", alignItems: "flex-start", gap: "0.65rem", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "10px", padding: "0.8rem 0.9rem" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: "1px" }}>
                  <circle cx="12" cy="12" r="9" stroke="#f59e0b" strokeWidth="1.7" />
                  <path d="M12 11V16" stroke="#f59e0b" strokeWidth="1.8" strokeLinecap="round" />
                  <circle cx="12" cy="8" r="0.8" fill="#f59e0b" />
                </svg>
                <p style={{ margin: 0, fontSize: "0.8rem", color: "#555", lineHeight: 1.6 }}>
                  You will be notified shortly.
                </p>
              </div>

              <style>{`
                @keyframes pulse {
                  0%, 100% { transform: scale(1); opacity: 1; }
                  50% { transform: scale(1.3); opacity: 0.6; }
                }
              `}</style>
            </div>

            {process.env.REACT_APP_CURRENT !== 'prod' && (
              <div style={{ padding: "0.75rem 1.25rem 1rem", display: "flex", justifyContent: "center" }}>
                <button
                  onClick={() => navigate("/eligibility/congratulations", { state: { data: userData } })}
                  style={{ background: "none", border: "none", color: "#bbb", fontSize: "0.78rem", cursor: "pointer", fontFamily: "Outfit, sans-serif", textDecoration: "underline" }}
                >
                  Skip
                </button>
              </div>
            )}
          <Footer light />
          </div>
        </div>
      </div>
    </div>
  );
}

export default EligibilityUnderReview;
